/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    ModalHeader: {
        id: 'qnb.spt.SgSptEssentialReasonListModal.ModalHeader',
        defaultMessage: 'Essential Reasons for Travel'
    },
    ModalListItem1: {
        id: 'qnb.spt.SgSptEssentialReasonListModal.ModalListItem1',
        defaultMessage: 'To accompany a person from the UK to go abroad, to a medical appointment, where you are a member of their household, or a close relative, as defined under the policy'
    },
    ModalListItem2: {
        id: 'qnb.spt.SgSptEssentialReasonListModal.ModalListItem2',
        defaultMessage: 'To visit someone who is dying, critically ill, or receiving treatment in a hospice'
    },
    ModalListItem3: {
        id: 'qnb.spt.SgSptEssentialReasonListModal.ModalListItem3',
        defaultMessage: 'To travel for a funeral, not for commemorative events or visiting burial grounds'
    }
});
